import { Grid, Typography } from "@mui/material";
import { useResponsive } from "../../../Modulo_Responsive/Hooks/useResponsive";
import quienesSomos from "../../../Recursos/quienes_somos.png"; // ajusta la ruta
import nuestroProposito from "../../../Recursos/nuestro_proposito.png"; // ajusta la ruta

const Quienes_Nuestro_Nosotros = () => {
    const { sCell } = useResponsive();

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            size={{ xs: 12 }}
            component="section"
        >
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                size={{ xs: 12, sm: 12, md: 10 }}
                sx={{ maxWidth: 1400, px: 3 }}
            >

                {/* ── Bloque 1: Quiénes somos ── */}
                <Grid
                    container
                    justifyContent="space-between"
                    alignItems="flex-start"
                    size={{ xs: 12 }}
                    sx={{ py:sCell?8:16, borderBottom: '1px solid #DFDFDF', borderTop: '1px solid #DFDFDF'}}
                    spacing={4}
                >
                    {/* Texto izquierda */}
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                        <Typography
                            component="h2"
                            variant="h2"
                            sx={{
                                mb: 4,
                                textAlign: sCell? 'center':'left',
                            }}
                        >
                            Quiénes somos
                        </Typography>

                        <Typography
                            component="p" variant={"body1"}
                            sx={{ mb: 2, textAlign: sCell? 'center':'left',}}
                        >
                            Salud en el Trabajo (SST) y adecuaciones técnicas, con un enfoque humano, consciente y profesional.
                        </Typography>

                        <Typography
                            component="p" variant={"body1"}
                            sx={{ mb: 2, textAlign: sCell? 'center':'left', }}
                        >
                            Acompañamos a personas, comunidades y organizaciones que necesitan algo más que ejecución: necesitan criterio técnico, acompañamiento cercano y soluciones reales que respondan a las condiciones reales del espacio y de quienes lo usan.
                        </Typography>

                        <Typography
                            component="p" variant={"body1"}
                            sx={{textAlign: sCell? 'center':'left', }}
                        >
                            Trabajamos como aliados técnicos, involucrándonos en cada proyecto con responsabilidad y respeto por la vida, el trabajo y el entorno.
                        </Typography>
                    </Grid>

                    {/* Imagen derecha */}
                        <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                            <img
                                src={quienesSomos}
                                alt="Quiénes somos - equipo de trabajo"
                                style={{ width: '100%', height: '400px', objectFit: 'cover' }}
                            />
                        </Grid>
                </Grid>

                {/* ── Bloque 2: Nuestro propósito ── */}
                <Grid
                    container
                    justifyContent="space-between"
                    alignItems="flex-start"
                    size={{ xs: 12 }}
                    sx={{ pt:sCell?8:16 }}
                    spacing={4}
                >
                    {/* Texto izquierda */}
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                        <Typography
                            component="h2"
                            variant={"h2"}
                            sx={{
                                mb: 4,
                                textAlign: sCell? 'center':'left',
                            }}
                        >
                            Nuestro propósito
                        </Typography>

                        <Typography
                            component="p" variant={"body1"}
                            sx={{mb: 2, textAlign: sCell? 'center':'left', }}
                        >
                            Nuestro propósito es crear y transformar espacios que cuiden a las personas, acompañando proyectos con decisiones responsables que protejan la vida, mejoren la experiencia diaria y aporten equilibrio entre seguridad, funcionalidad y bienestar.
                        </Typography>

                        <Typography
                            component="p" variant={"body1"}
                            sx={{ textAlign: sCell? 'center':'left', }}
                        >
                            Entendemos la arquitectura y la seguridad no solo como una obligación técnica, sino como una herramienta real de impacto social, confianza y tranquilidad para quienes habitan y construyen los espacios.
                        </Typography>
                    </Grid>

                    {/* Imagen derecha */}
                        <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                            <img
                                src={nuestroProposito}
                                alt="Nuestro propósito - planos arquitectónicos"
                                style={{ width: '100%', height: '320px', objectFit: 'cover' }}
                            />
                        </Grid>
                </Grid>

            </Grid>
        </Grid>
    );
};

export default Quienes_Nuestro_Nosotros;